import React from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import Navbar from "../../Landing/ForecastNestHome/navbar";
import Footer from "../../Landing/ForecastNestHome/footer";

const TermsCondition = () => {
  document.title = "Terms & Conditions | ForecastNest";
  return (
    <React.Fragment>
      <div className="layout-wrapper landing">
        <Navbar />
        <div className="page-content">
        <Container fluid>
          <Row className="justify-content-center">
            <Col lg={10}>
              <Card>
                <div className="bg-warning-subtle position-relative">
                  <CardBody className="p-5">
                    <div className="text-center">
                      <h3>Terms & Conditions</h3>
                      <p className="mb-0 text-muted">
                        Last update: August 23, 2026
                      </p>
                    </div>
                  </CardBody>
                  <div className="shape">
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsxlink="http://www.w3.org/1999/xlink" xmlnssvgjs="http://svgjs.com/svgjs" width="1440" height="60" preserveAspectRatio="none" viewBox="0 0 1440 60">
                      <g mask="url(&quot;#SvgjsMask1001&quot;)" fill="none">
                        <path d="M 0,4 C 144,13 432,48 720,49 C 1008,50 1296,17 1440,9L1440 60L0 60z" style={{ fill: "var(--vz-secondary-bg)" }}></path>
                      </g>
                      <defs>
                        <mask id="SvgjsMask1001">
                          <rect width="1440" height="60" fill="#FFFFFF"></rect>
                        </mask>
                      </defs>
                    </svg>
                  </div>
                </div>
                <CardBody className="p-4">
                  <div className="mb-4">
                    <div className="d-flex mb-3">
                      <div className="flex-shrink-0 me-3">
                        <FeatherIcon icon="check-circle" className="text-success icon-dual-success icon-xs" />
                      </div>
                      <div className="flex-grow-1">
                        <h5>Welcome to ForecastNest!</h5>
                      </div>
                    </div>
                    <p className="text-muted">
                      These terms and conditions outline the rules and regulations for the use of ForecastNest,
                      a research and record-keeping tool for market analysis produced by AI, located at
                      forecastnest.com.
                    </p>
                    <p className="text-muted">
                      By accessing this platform we assume you accept these terms and conditions. Do not continue 
                      to use ForecastNest if you do not agree to take all of the terms and conditions stated on this page.
                    </p>
                  </div>

                  <div className="mb-4">
                    <div className="d-flex mb-3">
                      <div className="flex-shrink-0 me-3">
                        <FeatherIcon icon="alert-circle" className="text-warning icon-dual-warning icon-xs" />
                      </div>
                      <div className="flex-grow-1">
                        <h5>Investment Disclaimer</h5>
                      </div>
                    </div>
                    <p className="text-muted">
                      <strong>IMPORTANT:</strong> ForecastNest provides AI-generated predictions for informational and 
                      educational purposes only. These predictions are NOT financial advice and should NOT be the sole 
                      basis for investment decisions.
                    </p>
                    <ul className="text-muted vstack gap-2">
                      <li>Cryptocurrency and stock trading involves substantial risk of loss</li>
                      <li>Past performance does not guarantee future results</li>
                      <li>AI predictions can be inaccurate and markets are unpredictable</li>
                      <li>You should never invest more than you can afford to lose</li>
                      <li>Consult with a qualified financial advisor before making investment decisions</li>
                    </ul>
                  </div>

                  <div className="mb-4">
                    <div className="d-flex mb-3">
                      <div className="flex-shrink-0 me-3">
                        <FeatherIcon icon="check-circle" className="text-success icon-dual-success icon-xs" />
                      </div>
                      <div className="flex-grow-1">
                        <h5>License and Usage</h5>
                      </div>
                    </div>
                    <p className="text-muted">
                      Unless otherwise stated, ForecastNest and/or its licensors own the intellectual property rights 
                      for all material on the platform. All intellectual property rights are reserved.
                    </p>
                    <p className="text-muted">You may access ForecastNest for your personal use subject to restrictions:</p>
                    <ul className="text-muted vstack gap-2">
                      <li>You must not republish material from ForecastNest</li>
                      <li>You must not sell, rent or sub-license material from ForecastNest</li>
                      <li>You must not reproduce, duplicate or copy material from ForecastNest</li>
                      <li>You must not redistribute content from ForecastNest</li>
                      <li>You must not scrape, reverse engineer, or extract data systematically</li>
                    </ul>
                  </div>

                  <div className="mb-4">
                    <div className="d-flex mb-3">
                      <div className="flex-shrink-0 me-3">
                        <FeatherIcon icon="check-circle" className="text-success icon-dual-success icon-xs" />
                      </div>
                      <div className="flex-grow-1">
                        <h5>User Accounts</h5>
                      </div>
                    </div>
                    <p className="text-muted">When you create an account with us, you must provide accurate and complete information.</p>
                    <p className="text-muted">You are responsible for:</p>
                    <ul className="text-muted vstack gap-2">
                      <li>Maintaining the confidentiality of your account credentials</li>
                      <li>All activities that occur under your account</li>
                      <li>Notifying us immediately of any unauthorized use</li>
                      <li>Ensuring you are at least 18 years old</li>
                    </ul>
                  </div>

                  <div className="mb-4">
                    <div className="d-flex mb-3">
                      <div className="flex-shrink-0 me-3">
                        <FeatherIcon icon="check-circle" className="text-success icon-dual-success icon-xs" />
                      </div>
                      <div className="flex-grow-1">
                        <h5>AI Predictions and Accuracy</h5>
                      </div>
                    </div>
                    <p className="text-muted">
                      Most research on ForecastNest is produced by an AI you supply. We build a structured
                      prompt; you run it in your own ChatGPT, Claude, Gemini or other account, and paste
                      the answer back for us to record and score. That means:
                    </p>
                    <ul className="text-muted vstack gap-2">
                      <li>Your use of that AI is governed by its provider's terms, not ours</li>
                      <li>We make no claim about how accurate any AI's output is, yours or ours</li>
                      <li>AI models may produce errors, biases, or incorrect forecasts</li>
                      <li>We record and score what you save; we do not verify that it is sensible, and you are responsible for what you paste in</li>
                      <li>Market conditions can change rapidly, making any forecast obsolete</li>
                    </ul>
                  </div>

                  <div className="mb-4">
                    <div className="d-flex mb-3">
                      <div className="flex-shrink-0 me-3">
                        <FeatherIcon icon="check-circle" className="text-success icon-dual-success icon-xs" />
                      </div>
                      <div className="flex-grow-1">
                        <h5>Subscription and Payments</h5>
                      </div>
                    </div>
                    <p className="text-muted">
                      Premium subscriptions provide access to additional features:
                    </p>
                    <ul className="text-muted vstack gap-2">
                      <li>Subscriptions automatically renew unless cancelled</li>
                      <li>You may cancel your subscription at any time, from your profile; cancelling stops the next payment and you keep access until the month you have paid for ends</li>
                      <li>Payments are processed by Stripe, which acts as merchant of record and is the seller for the transaction</li>
                      <li>We reserve the right to change subscription prices with notice</li>
                      <li>Each plan includes a monthly allowance of research prompts, which resets on the first of the month and does not carry over. Payments already made are not refunded, including the unused part of a month in progress — see our <a href="/refund-policy">Cancellation and Refund Policy</a>, which does not limit your statutory rights</li>
                    </ul>
                  </div>

                  <div className="mb-4">
                    <div className="d-flex mb-3">
                      <div className="flex-shrink-0 me-3">
                        <FeatherIcon icon="check-circle" className="text-success icon-dual-success icon-xs" />
                      </div>
                      <div className="flex-grow-1">
                        <h5>Prohibited Activities</h5>
                      </div>
                    </div>
                    <p className="text-muted">You agree not to:</p>
                    <ul className="text-muted vstack gap-2">
                      <li>Use the platform for any illegal purpose</li>
                      <li>Attempt to gain unauthorized access to our systems</li>
                      <li>Interfere with the proper functioning of the platform</li>
                      <li>Share your account with others</li>
                      <li>Use automated tools to access or scrape the platform</li>
                      <li>Misrepresent your affiliation with ForecastNest</li>
                    </ul>
                  </div>

                  <div className="mb-4">
                    <div className="d-flex mb-3">
                      <div className="flex-shrink-0 me-3">
                        <FeatherIcon icon="check-circle" className="text-success icon-dual-success icon-xs" />
                      </div>
                      <div className="flex-grow-1">
                        <h5>Limitation of Liability</h5>
                      </div>
                    </div>
                    <p className="text-muted">
                      <strong>TO THE MAXIMUM EXTENT PERMITTED BY LAW:</strong>
                    </p>
                    <ul className="text-muted vstack gap-2">
                      <li>ForecastNest is not liable for any financial losses arising from decisions you make</li>
                      <li>We are not responsible for the accuracy of any AI output, whether produced by your models or ours</li>
                      <li>We do not guarantee uninterrupted or error-free service</li>
                      <li>We are not liable for third-party actions or market conditions</li>
                      <li>Our total liability is limited to the amount you paid us in the last 12 months</li>
                    </ul>
                  </div>

                  <div className="mb-4">
                    <div className="d-flex mb-3">
                      <div className="flex-shrink-0 me-3">
                        <FeatherIcon icon="check-circle" className="text-success icon-dual-success icon-xs" />
                      </div>
                      <div className="flex-grow-1">
                        <h5>Service Modifications</h5>
                      </div>
                    </div>
                    <p className="text-muted">
                      We reserve the right to modify, suspend, or discontinue any part of the service at any time 
                      without notice. We may also update these terms and conditions periodically.
                    </p>
                  </div>

                  <div className="mb-4">
                    <div className="d-flex mb-3">
                      <div className="flex-shrink-0 me-3">
                        <FeatherIcon icon="check-circle" className="text-success icon-dual-success icon-xs" />
                      </div>
                      <div className="flex-grow-1">
                        <h5>Governing Law</h5>
                      </div>
                    </div>
                    <p className="text-muted">
                      These terms shall be governed by and construed in accordance with applicable laws.
                    </p>
                  </div>

                  <div className="mb-4">
                    <div className="d-flex mb-3">
                      <div className="flex-shrink-0 me-3">
                        <FeatherIcon icon="check-circle" className="text-success icon-dual-success icon-xs" />
                      </div>
                      <div className="flex-grow-1">
                        <h5>Contact Information</h5>
                      </div>
                    </div>
                    <p className="text-muted">
                      If you have any questions about these Terms & Conditions, please contact us at support@forecastnest.com
                    </p>
                  </div>

                  <div className="text-end mt-4">
                    <Link to="/" className="btn btn-primary">
                      Back to Home
                    </Link>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        </div>
        <Footer />
      </div>
    </React.Fragment>
  );
};

export default TermsCondition;
